import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
// eslint-disable-next-line
import classNames from "classnames";
import { v4 as uuidv4 } from "uuid"; // random
import onClickOutside from "react-onclickoutside";

// LIBS
import { getFI } from "../../../lib/user";

// Components
import Button from "../button";
import Dropdown from "../dropdown";
import Header from "../header";
import Input from "../input";
import P from "../paragraph";
import Row from "../row";
import Col from "../col";
import HR from "../hr";
import LogoLeo from "../logo/leo";
// Icons
import IconMenu from "../icons/menu";
// import IconApps from '../icons/apps';
import IconBasket from "../icons/basket";
// import IconHelp from '../icons/help';
import IconLeft from "../icons/arrowLeft";
import IconRight from "../icons/arrowRight";
import IconSearch from "../icons/search";
import VirtualDiv from "../virtualDiv";

/**
 * Width screens
 * @see: ../../style/grid/variables/_grid-variables.scss
 */
const XS_MAX = 575.98;
const SM_START = 576;
const SM_MAX = 767.98;
const MD_START = 768;
const MD_MAX = 991.98;
const LG_START = 992;
const LG_MAX = 1199.98;
const XL_START = 1200;

const WAIT_INTERVAL = 100;

// ----------------------------------------------
// Element: Malond Leo Icon
// ----------------------------------------------
function MalondLeoIcon(props) {
  return (
    <div>
      {props.mini ? <IconRight /> : <IconLeft />}

      <LogoLeo />
    </div>
  );
}

MalondLeoIcon.defaultProps = {
  mini: false
};

MalondLeoIcon.propTypes = {
  mini: PropTypes.bool
};

// ----------------------------------------------
// Element: Menu item
// ----------------------------------------------
function MenuItem({
  type,
  as,
  link,
  title,
  main,
  propsItem,
  icon,
  screen,
  handleMini
}) {
  const classNameLabel = "app-menu--item label";
  const classNameLink = classNames("app-menu--item link button black", {
    main: main,
    "with-icon": icon
  });

  const titleElement = icon ? (
    <VirtualDiv>
      {icon}
      <span className="title">{title}</span>
    </VirtualDiv>
  ) : (
    <span className="title">{title}</span>
  );

  switch (type) {
    case "as":
      return (
        <li>
          {React.createElement(
            as,
            {
              to: link,
              className: classNameLink,
              onClick: () => {
                // Скрываем меню, после того как нажали на мобильном
                // REVIEW: Уменьшаем размер
                if (screen.is_sm_down) {
                  handleMini();
                }
              }
            },
            titleElement
          )}
        </li>
      );
    case "link":
      return (
        <li>
          <a
            href={link}
            className={classNameLink}
            onClick={() => {
              // Скрываем меню, после того как нажали на мобильном
              // REVIEW: Уменьшаем размер
              if (screen.is_sm_down) {
                handleMini();
              }
            }}
          >
            {titleElement}
          </a>
        </li>
      );
    case "label":
      return (
        <li>
          <P size="x-small" upper className={classNameLabel}>
            {titleElement}
          </P>
        </li>
      );
    case "dropdown":
      const propsDropdown = Object.assign({}, propsItem, {
        type,
        as,
        link,
        title,
        main,
        icon
      });

      return (
        <li>
          {React.createElement(Dropdown, {
            ...propsDropdown
          })}
        </li>
      );
    default:
      return (
        <li>
          <a
            href={link}
            className={classNameLink}
            onClick={() => {
              // Скрываем меню, после того как нажали на мобильном
              // REVIEW: Уменьшаем размер
              if (screen.is_sm_down) {
                handleMini();
              }
            }}
          >
            {titleElement}
          </a>
        </li>
      );
  }
}

MenuItem.defaultProps = {
  icon: null
};

MenuItem.propTypes = {
  type: PropTypes.string,
  as: PropTypes.func,
  link: PropTypes.string,
  title: PropTypes.string.isRequired,
  main: PropTypes.bool,
  propsItem: PropTypes.object,
  icon: PropTypes.node,
  screen: PropTypes.object.isRequired,
  handleMini: PropTypes.func.isRequired
};

// ----------------------------------------------
// Element: Menu list
// ----------------------------------------------
function MenuList({ appMenu, screen, handleMini }) {
  const menuItems = appMenu.map(item => {
    const { id, type, as, link, title, main, icon, ...propsItem } = item;
    return (
      <MenuItem
        key={id || uuidv4()}
        type={type}
        as={as}
        link={link}
        title={title}
        main={main}
        propsItem={propsItem}
        icon={icon}
        screen={screen}
        handleMini={handleMini}
      />
    );
  });

  return <ul className="app-menu">{menuItems}</ul>;
}

MenuList.defaultProps = {
  appMenu: []
};

MenuList.propTypes = {
  appMenu: PropTypes.arrayOf(PropTypes.object),
  screen: PropTypes.object.isRequired,
  handleMini: PropTypes.func.isRequired
};

// ----------------------------------------------
// Element: Sub menu item
// ----------------------------------------------
function MenuSubItem({
  type,
  as,
  link,
  title,
  blank,
  button,
  propsItem,
  screen,
  handleMini,
  handleBack
}) {
  switch (type) {
    case "as":
      return (
        <li>
          {React.createElement(
            as,
            {
              to: link,
              className: "button white",
              onClick: () => {
                handleBack();

                // Скрываем меню, после того как нажали на мобильном
                // REVIEW: Уменьшаем размер
                if (screen.is_sm_down) {
                  handleMini();
                }
              }
            },
            title
          )}
        </li>
      );
    case "link":
      if (blank) {
        return (
          <li>
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              className="button white"
              onClick={() => {
                console.log("Click:");
                handleBack();

                // Скрываем меню, после того как нажали на мобильном
                // REVIEW: Уменьшаем размер
                if (screen.is_sm_down) {
                  handleMini();
                }
              }}
            >
              {title}
            </a>
          </li>
        );
      } else {
        return (
          <li>
            <a
              href={link}
              className="button white"
              onClick={() => {
                handleBack();

                // Скрываем меню, после того как нажали на мобильном
                // REVIEW: Уменьшаем размер
                if (screen.is_sm_down) {
                  handleMini();
                }
              }}
            >
              {title}
            </a>
          </li>
        );
      }
    case "button":
      return (
        <li>
          {React.createElement(
            Button,
            {
              ...(button || {}),
              ...{
                to: link || button.to || "/",
                onClick: e => {
                  handleBack();

                  // Скрываем меню, после того как нажали на мобильном
                  // REVIEW: Уменьшаем размер
                  if (screen.is_sm_down) {
                    handleMini();
                  }

                  if (button && button.onClick) {
                    button.onClick(e);
                  }
                }
              }
            },
            title
          )}
        </li>
      );
    case "hr":
      return (
        <li>
          <HR mutted margin="no" />
        </li>
      );
    default:
      return <li>{title}</li>;
  }
}

MenuSubItem.defaultProps = {
  icon: null,
  blank: false
};

MenuSubItem.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  as: PropTypes.func,
  link: PropTypes.string,
  title: PropTypes.string,
  blank: PropTypes.bool,
  button: PropTypes.object,
  screen: PropTypes.bool.isRequired,
  handleMini: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired
};

// ----------------------------------------------
// Element: Menu list
// ----------------------------------------------
function MenuSubList({ subMenu, screen, handleMini, handleBack }) {
  const menuItems = subMenu.map(item => {
    const { id, type, as, link, title, blank, button, ...propsItem } = item;

    console.log("MenuSubItem:", item);

    return (
      <MenuSubItem
        key={id || uuidv4()}
        type={type}
        as={as}
        link={link}
        title={title}
        blank={blank}
        button={button}
        propsItem={propsItem}
        screen={screen}
        handleMini={handleMini}
        handleBack={handleBack}
      />
    );
  });

  return <ul className="app-menu--list">{menuItems}</ul>;
}

MenuSubList.defaultProps = {
  subMenu: []
};

MenuSubList.propTypes = {
  subMenu: PropTypes.arrayOf(PropTypes.object),
  screen: PropTypes.object.isRequired,
  handleMini: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired
};

// ----------------------------------------------
// Element: Sub menu
// ----------------------------------------------
function MenuSub({
  selected,
  search,
  menuHelp,
  menuApps,
  menuUser,
  screen,
  handleMini,
  handleBack
}) {
  switch (selected) {
    case "apps":
      return (
        <MenuSubList
          subMenu={[{ type: "hr" }, ...menuApps]}
          screen={screen}
          handleMini={handleMini}
          handleBack={handleBack}
        />
      );
    case "search":
      return (
        <div className="app-menu--search">
          <form className="form" onSubmit={search && search.handleFormSubmit}>
            <Input
              focus={(search && search.focus) || false}
              name="search"
              value={(search && search.value) || ""}
              placeholder={
                (search && search.placeholder) || "Номер билета, документа..."
              }
              handleChange={search && search.handleInput}
            />
          </form>

          {search && search.isNoResult ? (
            search && search.noResult
          ) : (
            <ul>{search && search.list}</ul>
          )}
        </div>
      );
    case "help":
      return (
        <MenuSubList
          subMenu={[{ type: "hr" }, ...menuHelp]}
          screen={screen}
          handleMini={handleMini}
          handleBack={handleBack}
        />
      );
    case "user":
      return (
        <div className="app-menu--user">
          <MenuSubList
            subMenu={[{ type: "hr" }, ...menuUser]}
            screen={screen}
            handleMini={handleMini}
            handleBack={handleBack}
          />
        </div>
      );
    default:
      return <div />;
  }
}

MenuSub.defaultProps = {
  search: {}
};

MenuSub.propTypes = {
  selected: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  search: PropTypes.object,
  menuHelp: PropTypes.arrayOf(PropTypes.object),
  menuApps: PropTypes.arrayOf(PropTypes.object),
  menuUser: PropTypes.arrayOf(PropTypes.object),
  screen: PropTypes.object.isRequired,
  handleMini: PropTypes.func.isRequired,
  handleBack: PropTypes.func.isRequired
};

// ----------------------------------------------
// Class: Menu
// ----------------------------------------------
class Menu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      appName: this.props.options.name,
      active: false,
      mini: false,
      selectedSubMenu: false,
      searchInputFocus: false,

      screen: {
        is_xs_down: false,

        is_sm_only: false,
        is_sm_up: false,
        is_sm_down: false,

        is_md_only: false,
        is_md_up: false,
        is_md_down: false,

        is_lg_only: false,
        is_lg_up: false,
        is_lg_down: false,

        is_xl_up: false
      },

      convertToMiniWithResize: false,
      screenWidth: 0,
      screenHeight: 0
    };

    this.handleMini = this.handleMini.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleApps = this.handleApps.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleHelp = this.handleHelp.bind(this);
    this.handleUser = this.handleUser.bind(this);

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    clearTimeout(this.timer);

    let screenWidth = window.innerWidth;
    let screenHeight = window.innerHeight;

    let is_xs_down = screenWidth <= XS_MAX;

    let is_sm_only = screenWidth >= SM_START && screenWidth <= SM_MAX;
    let is_sm_up = screenWidth >= SM_START;
    let is_sm_down = screenWidth <= SM_MAX;

    let is_md_only = screenWidth >= MD_START && screenWidth <= MD_MAX;
    let is_md_up = screenWidth >= MD_START;
    let is_md_down = screenWidth <= MD_MAX;

    let is_lg_only = screenWidth >= LG_START && screenWidth <= LG_MAX;
    let is_lg_up = screenWidth >= LG_START;
    let is_lg_down = screenWidth <= LG_MAX;

    let is_xl_up = screenWidth >= XL_START;

    let screen = {
      is_xs_down,
      is_sm_only,
      is_sm_up,
      is_sm_down,
      is_md_only,
      is_md_up,
      is_md_down,
      is_lg_only,
      is_lg_up,
      is_lg_down,
      is_xl_up
    };

    this.timer = setTimeout(
      () => this.triggerScreenResize({ screenWidth, screenHeight }, screen),
      WAIT_INTERVAL
    );
  }

  triggerScreenResize = ({ screenWidth, screenHeight }, screen) => {
    let convertToMiniWithResize = this.state.convertToMiniWithResize;
    let mini = this.state.mini;

    // С большого до маленького
    if (!convertToMiniWithResize) {
      // Если ещё не уменьшали
      if (!mini) {
        // REVIEW: Уменьшаем размер
        // sm и ниже
        if (screen.is_sm_down) {
          convertToMiniWithResize = true;
          mini = true;
        }
      }

      // С маленького до большого
    } else {
      // Если ещё не уменьшали
      if (mini) {
        // REVIEW: Уменьшаем размер
        // sm и выше
        if (screen.is_sm_up) {
          convertToMiniWithResize = false;
          mini = false;
        }
      }
    }

    this.setState({
      screen,
      convertToMiniWithResize,
      mini,
      screenWidth,
      screenHeight: window.innerHeight
    });
  };

  // componentWillReceiveProps(nextProps) {
  //   // eslint-disable-next-line
  //   if (this.state.appName != nextProps.options.name) {
  //     this.setState({appName: nextProps.options.name})
  //   }
  // }

  // eslint-disable-next-line
  handleClickOutside = () => {
    if (this.state.active) {
      this.handleBack();
    }
  };

  /* Handle */
  handleMini() {
    this.setState(prevState => ({
      mini: !prevState.mini
    }));
  }

  handleBack() {
    this.setState(() => ({
      active: false,
      appName: this.props.options.name,
      selectedSubMenu: false,
      searchInputFocus: false
    }));
  }

  handleApps() {
    this.setState(prevState => ({
      active: !prevState.active,
      appName: prevState.active ? this.props.options.name : "Приложения",
      selectedSubMenu: prevState.selectedSubMenu ? false : "apps"
    }));
  }

  handleSearch() {
    this.setState(prevState => ({
      active: !prevState.active,
      appName: prevState.active ? this.props.options.name : "Поиск",
      selectedSubMenu: prevState.selectedSubMenu ? false : "search",
      searchInputFocus: true
    }));
  }

  handleHelp() {
    this.setState(prevState => ({
      active: !prevState.active,
      appName: prevState.active ? this.props.options.name : "Помощь",
      selectedSubMenu: prevState.selectedSubMenu ? false : "help"
    }));
  }

  handleUser() {
    this.setState(prevState => ({
      active: !prevState.active,
      appName: prevState.active
        ? this.props.options.name
        : this.props.user.f && this.props.user.i
        ? `${this.props.user.i} ${this.props.user.f}`
        : `${this.props.user.email}`,
      selectedSubMenu: prevState.selectedSubMenu ? false : "user"
    }));
  }

  render() {
    const menuClasses = classNames({
      menu: true,
      global: true,
      selectedSubMenu: false,
      mini: this.state.mini || !this.props.options.showRightPanel,
      active: this.state.active,
      // REVIEW: Уменьшаем размер
      mobile: this.state.screen.is_sm_down
    });

    const { user } = this.props;

    let SearchButton = <div />;
    let SellButton = <div />;
    if (this.props.options.search && this.props.options.search.show) {
      SearchButton = (
        <Button
          circle
          theme="black"
          size="m"
          vertical
          onClick={this.handleSearch}
        >
          <IconSearch />
        </Button>
      );
    }
    if (this.props.options.showSell) {
      SellButton = (
        <Button
          type="as"
          as={Link}
          to={this.props.options.linkSell}
          circle
          theme="primary"
          size="l"
          vertical
        >
          <IconBasket />
        </Button>
      );
    }

    const appLogoLeoClasses = classNames("app-logo-leo", {
      inactive: !this.props.options.activeLogo
    });

    let appName = null;

    if (this.state.appName || this.props.options.subname) {
      let appNameHeader = this.state.appName ? (
        <Header size={4} slim={true} margin="no" className="app-name--header">
          {this.state.appName}
        </Header>
      ) : null;
      let appNameSub =
        !this.state.mini && this.props.options.subname ? (
          <Header size={6} slim={true} margin="no" className="app-name--sub">
            {this.props.options.subname}
          </Header>
        ) : null;

      appName = (
        <Row className="app-name" align="center">
          <Col padding="no">
            <Row withMain={true} align="center" className="app-name--row">
              <Col normal={true} padding="no">
                <Button
                  circle
                  theme="default"
                  vertical
                  className="app-name--back"
                  onClick={this.handleBack}
                >
                  <IconLeft />
                </Button>
              </Col>
              <Col main={true} padding="no">
                {appNameHeader}
                {appNameSub}
              </Col>
            </Row>
          </Col>
        </Row>
      );
    }

    return (
      <nav className={menuClasses}>
        {/* Показываем меню в мобильной версии */}
        <div className="mobile-menu-header">
          <Button
            className="show-menu"
            theme="grey"
            size="s"
            outline={true}
            onClick={() => {
              this.setState({ mini: false });
            }}
          >
            <IconMenu />
          </Button>

          <P slim={true} strong={true} className="mobile-title">
            {/* {this.getMobileTitle()} */}
            {this.props.title}
          </P>
          {/* {this.props.options.name} */}
        </div>

        {/* Основное меню */}
        <Row className="h-100 app-menu--row" withMain={true}>
          <Col className="left h-100" padding="no" normal={true} text="center">
            <Row flexColumn className="h-100" withMain={true}>
              <Col normal={true} padding="no">
                <Button
                  theme="dark"
                  outline
                  className={appLogoLeoClasses}
                  onClick={
                    this.props.options.activeLogo
                      ? this.handleMini
                      : () => false
                  }
                >
                  <MalondLeoIcon mini={this.state.mini} />
                </Button>
              </Col>
              <Col main={true} padding="s">
                {SellButton}
                {SearchButton}
              </Col>
              <Col normal={true} padding="s">
                {/* <Button circle theme="black" size="s" vertical onClick={this.handleApps}>
                  <IconApps />
                </Button> */}
                {/* <Button circle theme="black" size="s" vertical onClick={this.handleHelp}>
                  <IconHelp />
                </Button> */}
                <Button
                  circle
                  theme="black"
                  size="l"
                  vertical
                  onClick={this.handleUser}
                >
                  {getFI(user.i, user.f, user.email)}
                </Button>
              </Col>
            </Row>
          </Col>
          <Col className="right h-100" main={true} padding="no">
            {appName}

            <MenuList
              appMenu={this.props.options.menu}
              screen={this.state.screen}
              handleMini={this.handleMini}
            />

            <MenuSub
              selected={this.state.selectedSubMenu}
              search={this.props.options.search}
              menuHelp={this.props.options.menuHelp}
              menuApps={this.props.options.menuApps}
              menuUser={this.props.options.menuUser}
              screen={this.state.screen}
              handleMini={this.handleMini}
              handleBack={this.handleBack}
            />
          </Col>
        </Row>

        <div
          className="mobile-menu-close"
          onClick={() => {
            this.setState({
              mini: true,
              active: false,
              appName: this.props.options.name,
              selectedSubMenu: false,
              searchInputFocus: false
            });
          }}
        />
      </nav>
    );
  }
}

Menu.propTypes = {
  // eslint-disable-next-line
  options: PropTypes.shape({
    name: PropTypes.string,
    subname: PropTypes.string
  }).isRequired,
  // eslint-disable-next-line
  user: PropTypes.object.isRequired
};

export default onClickOutside(Menu);
